var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    [
      _c("template", { slot: "content" }, [
        _c("div", { staticClass: "flex-level mb-3" }, [
          _c("h2", { staticClass: "m-0" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$l10n.__("Statistiques")) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-level flex-item-right" },
            [
              _c("select-input", {
                staticClass: "dinlineb mr-3",
                attrs: { mode: "edit", options: _vm.periods },
                on: { input: _vm.fetchStat },
                model: {
                  value: _vm.period,
                  callback: function($$v) {
                    _vm.period = $$v
                  },
                  expression: "period"
                }
              }),
              _vm._v(" "),
              _vm.currencies.length > 1
                ? _c("select-input", {
                    staticClass: "dinlineb",
                    attrs: {
                      mode: "edit",
                      options: _vm.currencies,
                      filterable: true,
                      labelColumn: "name",
                      idColumn: "id"
                    },
                    on: { input: _vm.fetchStat },
                    model: {
                      value: _vm.currency,
                      callback: function($$v) {
                        _vm.currency = $$v
                      },
                      expression: "currency"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "prelative" },
          [
            _c("preloader", {
              staticClass: "mt-5",
              attrs: { display: _vm.loading }
            })
          ],
          1
        ),
        _vm._v(" "),
        !_vm.loading
          ? _c(
              "div",
              {
                staticClass: "flex-level fw-wrap",
                staticStyle: { "align-items": "baseline" }
              },
              _vm._l(_vm.cardFormatted, function(card, indexCard) {
                return _c(
                  "div",
                  {
                    key: indexCard,
                    staticClass: "stat-card no-shrink well p-0"
                  },
                  [
                    _c(card.component, {
                      tag: "component",
                      attrs: { data: card }
                    })
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }